import { Alert, Snackbar, Typography, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import { useIsOnline } from '../../hooks/useIsOnline';
import { useEffect, useState } from 'react';

export default function SyncSuccessToast() {
  const { syncStatus } = useIsOnline();
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    // Show success toast when sync completes
    if (!syncStatus.isSyncing && syncStatus.syncedCount > 0 && syncStatus.totalToSync > 0) {
      setShowSuccess(true);
    }
  }, [syncStatus]);

  const handleClose = () => {
    setShowSuccess(false);
  };

  return (
    <Snackbar
      open={showSuccess}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ mt: 8 }}>
      <Alert
        onClose={handleClose}
        severity="success"
        variant="filled"
        icon={<CloudDoneIcon />}
        sx={{
          backgroundColor: '#10b981',
          color: 'white',
          boxShadow: '0 8px 32px rgba(16, 185, 129, 0.3)',
          borderRadius: 2,
          minWidth: '300px'
        }}>
        <Box>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
            Sync Complete
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.95 }}>
            Successfully synced {syncStatus.syncedCount} manifest submission{syncStatus.syncedCount !== 1 ? 's' : ''}
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
}
